import {createSlice} from "@reduxjs/toolkit";
import {
  clearToggleDriverActivityPagePerson,
  setDriverActivityPageCriteria,
  setDriverActivityPageFilter,
  setDriverActivityPageState,
  toggleDriverActivityPagePerson
} from "./actions";
import {
  DEFAULT_DRIVER_ACTIVITY_FILTER,
  DriverActivityFilterFormValues
} from "../../../components/form/DriverActivityFilterForm/DriverActivityFilterForm";
import {GridState} from "@ag-grid-community/core";
import {TransportSearchCriteria} from "@ots-frontend/ots-data";

type State = {
  criteria?: TransportSearchCriteria
  filter: DriverActivityFilterFormValues
  hiddenPersonIds: string[]
  state?: GridState
}

const INITIAL_STATE: Readonly<State> = {
  criteria: undefined,
  filter: DEFAULT_DRIVER_ACTIVITY_FILTER,
  hiddenPersonIds: [],
  state: undefined
};

const driverActivityPageSlice = createSlice({
  name: "ots-ui/driver-activity-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setDriverActivityPageCriteria,
      (state, {payload}) => {
        state.criteria = payload
      }
    );
    builder.addCase(
      setDriverActivityPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setDriverActivityPageState,
      (state, {payload}) => {
        state.state = payload
      }
    );
    builder.addCase(
      toggleDriverActivityPagePerson,
      (state, {payload}, ) => {
        const index = state.hiddenPersonIds.findIndex(id => id === payload)
        if (index === -1) {
          state.hiddenPersonIds.push(payload)
        } else {
          state.hiddenPersonIds.splice(index, 1)
        }
      }
    );
    builder.addCase(
      clearToggleDriverActivityPagePerson,
      (state, {payload}, ) => {
        state.hiddenPersonIds = []
      }
    );
  }
});

export const driverActivityPageReducer = driverActivityPageSlice.reducer;
